import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import AddCustomerDialog from "./AddCustomer";
import DisposeDialPhone from "./DisposeDialPhone";
import {
  Grid,
  Typography,
  Accordion as MuiExpansionPanel,
} from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";

//store
import * as actions from "../../../../store/actions/actionIndex";
// uitility function
import { decryptPhoneNumber, maskedNumber } from "../../../../helpers/utility";

const useStyles = makeStyles((theme) => ({
  DispositionTitle: {
    color: "white",
    backgroundColor: "#242a5a",
    fontSize: "15px",
    lineHeight: "18px",
    marginBottom: -1,
    padding: "16px 25px 16px 24px",
    minHeight: 40,
    "&$expanded": {
      minHeight: 40,
    },
  },
}));

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiExpansionPanel);



function PhoneTypes(props) {
  var classes = useStyles();
  const [showAddCustomer, setShowAddCustomer] = useState(false);

  useEffect(() => {
    const savedInitialLeadId = localStorage.getItem("initialLeadId");
    const currentLeadId = props.leadId?.toString();
  
    if (props.callType === "INBOUND") {
      if (!savedInitialLeadId) {
        localStorage.setItem("initialLeadId", currentLeadId);
        setShowAddCustomer(true);
      } else if (currentLeadId !== savedInitialLeadId) {
        setShowAddCustomer(false);
      } else {
        setShowAddCustomer(true);
      }
    } else {
      if (!props.leadId || props.leadId === "0") {
        setShowAddCustomer(true);
      } else {
        setShowAddCustomer(false);
      }
    }
  }, [props.leadId, props.callType]);

  const handleCallPark = () =>{
    props.onCallPark(props.agentId, props.custPhone)
  }
  

  return (
    <Grid
      className={classes.DispositionGrid}
      item
      xs={false}
      md={false}
      lg={false}
    >
      <Accordion>
        <Typography className={classes.DispositionTitle} key={props.leadId}>
          Customer Details
        </Typography>
      </Accordion>

<div style={{ margin: "20px 0 10px 0" }}>
   <Grid container spacing={1}>
     <DisposeDialPhone agentId={props.agentId} phoneNum={props.custPhone} ivrsPath ={props.ivrsPath} handleCallPark = {handleCallPark} callPark={props.campConf.call_park} campaignId={props.facilityConf.campaign_id} label="Phone 1" value={props.facilityConf.enable_number_mask ? props.facilityConf.enable_number_mask === "1" ? maskedNumber(props.custPhone, props.facilityConf.mask_start_pos, props.facilityConf.mask_end_pos) : decryptPhoneNumber(props.custPhone) : decryptPhoneNumber(props.custPhone)} />
         {false && props.leadId && props.leadId !== "0" && (
                                                <>
                                                        <DisposeDialPhone label="Phone 2" />
                                                        <DisposeDialPhone label="Phone 3" />
                                                        <DisposeDialPhone label="Phone 4" />
                                                        <DisposeDialPhone label="Phone 5" />
                                                        <DisposeDialPhone label="Phone 6" />
                                                        <DisposeDialPhone label="Phone 7" />
                                                        <DisposeDialPhone label="Phone 8" />
                                                        <DisposeDialPhone label="Phone 9" />
                                                </>
                                        )}
                                </Grid>
                                {showAddCustomer && <AddCustomerDialog />}
                                {/* {}
                                {
                                    (!props.leadId || props.leadId === "0") && <AddCustomerDialog />
                                  
                                } */}
                               
                        </div>

    </Grid>
  );
}

const mapStateToProps = (state) => {
  return {
    error: state.callDisp.error,
    loading: state.callDisp.loading,
    disconnectError: state.agentDisconnect.error,
    disconnectLoading: state.agentDisconnect.loading,
    custPhone: state.agentData.custPhone,
    leadId: state.agentData.leadId,
    agentState: state.agentData.agentState,
    agentCallType: state.agentData.call_type,
    facilityConf: state.agentConfig.facilityConf,
    campConf: state.agentConfig.campConf,
    ivrsPath: state.agentData.ivrsPath,
    callType: state.agentData.callType,
    agentId: state.agentData.agentId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAgentDisconnect: (agentId, feedbackFlag, callStatus) =>
      dispatch(actions.agentDisconnect(agentId, feedbackFlag, callStatus)),
    onCallPark: (agentId, phoneNo) => dispatch(actions.callPark(agentId, phoneNo))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PhoneTypes);
